/**
 * 生協間コピー設定画面の生協クラス
 *
 * @export CoopInfo
 * @class CoopInfo
 */
export class CoopInfo {
  check = false;
  constructor(public coopCode: string, public coopName: string) {}
}
